<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » 展示情報詳細（追加・編集）の説明
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>展示情報詳細（追加・編集）の説明</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/exhibit-dialog.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> 閉じるボタン
        </div>
        <div class="manual-explain">
          クリックすることでダイアログを閉じます。<br>
          その際、編集した内容は保存されません。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> ID
        </div>
        <div class="manual-explain">
          IDを設定します。<br>
          <span class="manual-explain-notes">※必須項目</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> 展示属性
        </div>
        <div class="manual-explain">
          展示属性を選択します。<br>
          ※<a [href]="exhibitAttributeDialogLink">展示属性画面</a>で登録された情報から選択します。<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> 名称
        </div>
        <div class="manual-explain">
          名称を設定します。<br>
          編集ボタンから<a [href]="nameDialogLink">編集用ダイアログ</a>を開き設定します。<br>
          <span class="manual-explain-notes">※必須項目</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> 詳細
        </div>
        <div class="manual-explain">
          詳細を設定します。<br>
          編集ボタンから<a [href]="descDialogLink">編集用ダイアログ</a>を開き設定します。<br>
          <span class="manual-explain-notes">※必須項目</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/F.png"> マップ情報
        </div>
        <div class="manual-explain">
          マップ情報を設定します。<br>
          マップ内の検索キーワード、または緯度軽度から指定可能です。<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/G.png"> MAPページに位置を表示する
        </div>
        <div class="manual-explain">
          チェックを入れることで、MAPページにGoogleMapを表示しピンを立てます。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/H.png"> 画像の上に詳細概要を重ねない
        </div>
        <div class="manual-explain">
          チェックを入れることで、展示物ページの画像の上に展示物概要を重ねないようにします。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/I.png"> 展示画像ファイル
        </div>
        <div class="manual-explain">
          展示物のメイン画像を設定します。<br>
          ファイル追加ボタンからファイルを選択します。<br>
          ※ファイルは、<a [href]="uploaderLink">アップロードファイル画面</a>で事前にアップロードしてある必要があります。<br>
          ※言語ごとの画像設定が可能です。該当言語の画像がない場合は英語用、英語用の画像が登録されない場合は日本語用の画像が表示されます。<br>
          メイン画像は複数登録可能です。複数登録した場合、画像はスライド表示されます。<br>
          また、展示画像はドラッグ&ドロップで並び替えが可能です。<br>
          ※画像の推奨サイズ（縦横比）は以下になります。<br>
          &nbsp;&nbsp;メイン画像：1 : 1（例）高さ1400px、幅1400px
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/J.png"> YouTube埋め込みコード
        </div>
        <div class="manual-explain">
          YouTubeの埋め込みコードを設定します。<br>
          編集ボタンから<a [href]="youtubeDialogLink">編集用ダイアログ</a>を開き設定します。<br>
          画像の代わりにYouTube動画を表示させたい場合は「YouTubeを使用する」にチェックを入れて下さい。<br>
          ※メインで表示されるコンテンツは画像、YouTube動画の何かになります。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/K.png"> 外部リンク
        </div>
        <div class="manual-explain">
          外部リンクの名称、URLを設定します。<br>
          編集ボタンから<a [href]="nameDialogLink">編集用ダイアログ（名称）</a>、<a [href]="urlDialogLink">編集用ダイアログ（URL）</a>を開き設定します。<br>
          外部リンクを表示させたい場合は「外部リンクを使用する」にチェックを入れて下さい。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/L.png"> 展示詳細リスト
        </div>
        <div class="manual-explain">
          展示詳細を設定します。<br>
          展示詳細リスト追加ボタンから展示詳細を選択します。<br>
          ※展示詳細は、<a [href]="exhibitDetailDialogLink">展示詳細情報画面</a>で事前に登録してある必要があります。<br>
          展示詳細リストはドラッグ&ドロップで並び替えが可能です。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/M.png"> 予約設備リスト
        </div>
        <div class="manual-explain">
          予約設備を設定します。<br>
          予約設備リスト追加ボタンから予約設備を選択します。<br>
          ※予約設備は、<a [href]="reservationFacilityDialogLink">予約設備情報画面</a>で事前に登録してある必要があります。<br>
          予約設備リストはドラッグ&ドロップで並び替えが可能です。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/N.png"> 更新ボタン
        </div>
        <div class="manual-explain">
          クリックすることで編集内容が更新されます。
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">User Guide Top</a> » Explanation of Exhibit Information Details (Add/Edit)
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Explanation of Exhibit Information Details (Add/Edit)</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_exhibit-dialog.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> Close Button
        </div>
        <div class="manual-explain">
          Click to close the dialog.<br>
          Any edited content will not be saved.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> ID
        </div>
        <div class="manual-explain">
          Set the ID.<br>
          <span class="manual-explain-notes">*Required field</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Exhibit Attribute
        </div>
        <div class="manual-explain">
          Select the exhibit attribute.<br>
          *Select from information registered on the <a [href]="exhibitAttributeDialogLink">Exhibit Attribute Screen</a>.<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> Name
        </div>
        <div class="manual-explain">
          Set the name.<br>
          Open the <a [href]="nameDialogLink">edit dialog</a> from the edit button to configure.<br>
          <span class="manual-explain-notes">*Required field</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> Detail
        </div>
        <div class="manual-explain">
          Set the details.<br>
          Open the <a [href]="descDialogLink">edit dialog</a> from the edit button to configure.<br>
          <span class="manual-explain-notes">*Required field</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/F.png"> Map Information
        </div>
        <div class="manual-explain">
          Set the map information.<br>
          Can be specified by search keywords within the map or by latitude and longitude.<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/G.png"> Show Location on MAP Page
        </div>
        <div class="manual-explain">
          Check to display Google Map with a pin on the MAP page.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/H.png"> Don't Overlay Detail Summary on Image
        </div>
        <div class="manual-explain">
          Check to prevent the exhibit summary from overlaying on the image on the exhibit page.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/I.png"> Exhibit Image Files
        </div>
        <div class="manual-explain">
          Set the main image for the exhibit.<br>
          Select files using the Add File button.<br>
          *Files must be uploaded in advance on the <a [href]="uploaderLink">Upload Files screen</a>.<br>
          *Image settings for each language are possible. If there is no image for the corresponding language, English images will be displayed, and if no English image is registered, Japanese images will be displayed.<br>
          Multiple main images can be registered. When multiple images are registered, they will be displayed as a slideshow.<br>
          Exhibit images can also be reordered by drag & drop.<br>
          *The recommended image size (aspect ratio) is as follows:<br>
          &nbsp;&nbsp;Main image: 1:1 (Example) Height 1400px, Width 1400px
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/J.png"> YouTube Embed Code
        </div>
        <div class="manual-explain">
          Set the YouTube embed code.<br>
          Open the <a [href]="youtubeDialogLink">edit dialog</a> from the edit button to configure.<br>
          If you want to display a YouTube video instead of an image, check "Use YouTube".<br>
          *The main displayed content will be either an image or YouTube video.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/K.png"> External Link
        </div>
        <div class="manual-explain">
          Set the name and URL of the external link.<br>
          Open the <a [href]="nameDialogLink">edit dialog (Name)</a> and <a [href]="urlDialogLink">edit dialog (URL)</a> from the edit button to configure.<br>
          If you want to display an external link, check "Use External Link".
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/L.png"> Exhibit Detail List
        </div>
        <div class="manual-explain">
          Set exhibit details.<br>
          Select exhibit details using the Add Exhibit Detail List button.<br>
          *Exhibit details must be registered in advance on the <a [href]="exhibitDetailDialogLink">Exhibit Detail Information screen</a>.<br>
          The exhibit detail list can be reordered by drag & drop.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/M.png"> Reservation Facility List
        </div>
        <div class="manual-explain">
          Set reservation facilities.<br>
          Select reservation facilities using the Add Reservation Facility List button.<br>
          *Reservation facilities must be registered in advance on the <a [href]="reservationFacilityDialogLink">Reservation Facility Information screen</a>.<br>
          The reservation facility list can be reordered by drag & drop.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/N.png"> Update Button
        </div>
        <div class="manual-explain">
          Click to update the edited content.
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>